import { render, staticRenderFns } from "./BsComboboxListContainer.vue?vue&type=template&id=1f05a6d1&scoped=true&"
import script from "./BsComboboxListContainer.vue?vue&type=script&lang=js&"
export * from "./BsComboboxListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05a6d1",
  null
  
)

export default component.exports